import { Link, Outlet } from 'react-router-dom';

export function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-900">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            Patern
          </Link>
          <nav className="flex items-center gap-6 text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">
              Home
            </Link>
            <Link to="/explorer" className="hover:text-gray-900">
              Explorer
            </Link>
            <Link to="/buy-plans" className="hover:text-gray-900">
              Buy plans
            </Link>
            <Link to="/pipeline" className="hover:text-gray-900">
              Pipeline
            </Link>
            <Link to="/healthz" className="hover:text-gray-900">
              Status
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-10">
        <Outlet />
      </main>
      <footer className="border-t border-gray-200 bg-white py-4 text-center text-xs text-gray-500">
        Patern · v0
      </footer>
    </div>
  );
}
